// All of our hostnames.
const isLocalHost = () => window.location.host.search('localhost') >= 0
const stagingHostName = () => 'attach-alpha.mikmak.tv'
const bananaRepublicHostName = () => 'attach-demo.mikmak.tv'
const secureStagingHostName = () => 'attach-dev.mikmak.tv'
const productionHostName = () => 'attach.mikmak.tv'
const betaHostName = () => 'beta.mikmak.tv'
const drBrandtHostName = () => 'drbrandt.mikmak.tv'
const secureProductionHostName = () => 'attach-prod.mikmak.tv'

// Production attach, but ignore traffic and events because it is a visual test.
const isVisualTest = window.location.search.indexOf('internalVisualTest') != -1
const isTestPurchase = window.location.search.indexOf('testpurchase') != -1
const noPlayDemo = window.location.search.indexOf('noPlayDemo') != -1

const isGalleryView = window.location.href.indexOf('.mikmak.tv/gallery') != -1

// Determine if current env is Production or not.
const isProduction = () => {
  if (isDesktop()) return false
  if (isVisualTest) return false

  let host = window.location.host
  return host == productionHostName() || host == drBrandtHostName() ||
         host == secureProductionHostName() || host == bananaRepublicHostName() ||
         host == betaHostName()
}

// We run tests using Phantom JS. User agent will be electron. We
// have to fire events in prod, but we want to be able to mark them as test.
const isTestEvent = () => window.navigator.userAgent.search('Electron') != -1

// See if a social media ID is in user agent.
const isInstagram = window.navigator.userAgent.search('Instagram') != -1
const isFacebook = window.navigator.userAgent.search('FBAN') != -1 || window.navigator.userAgent.search('FBAV') != -1
const isSnapchat = window.navigator.userAgent.search('Snapchat') != -1
const isAndroid = window.navigator.appVersion.search('Android') != -1
const isInternetExplorer = (window.navigator.userAgent.search('Explorer') != -1 || window.navigator.userAgent.search('Edge') != -1)

// Determine if client is visiting from Desktop.
const isDesktop = () => {
  var isDesktop = true

  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isDesktop = false;

  if (window.navigator.platform == 'MacIntel') isDesktop = true
  if (window.navigator.platform == 'Windows') isDesktop = true

  return isDesktop
};

const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
const guid = () => s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()

const getCurrentDate = () => {
  let d = new Date()
  let yr = d.getFullYear()
  let mo = d.getMonth() + 1
  if (mo < 10) mo = '0' + String(mo)
  let day = d.getDate()
  if (day < 10) day = '0' + String(day)

  return `${yr}${mo}${day}`
}

const sortByKey = (array, key) => {
  return array.sort(function(a, b) {
    var x = a[key]; var y = b[key];
    return ((x > y) ? -1 : ((x < y) ? 1 : 0));
  });
}

const sortArrayByDate = (array, key) => {
  return array.sort(function(a, b) {
    var x = new Date(a[key])
    var y = new Date(b[key])
    return ((x > y) ? -1 : ((x < y) ? 1 : 0))
  });
}

const sortArrayByNumber = (array, key) => {
  return array.sort(function(a, b) {
    var y = Number(a[key])
    var x = Number(b[key])
    return ((x > y) ? -1 : ((x < y) ? 1 : 0))
  });
}

const getConstantKeyFromStore = (state, key) => {
  let constants = state.constants
  let text = constants[key].default
  if (state.currentPlayerLanguage) {
    let language = state.currentPlayerLanguage
    if (constants[key][language]) {
      text = constants[key][language]
    }
  }

  return text
}

// Is the app currently visible to the user or not?
const appIsHidden = () => {
  if (document.hidden) return true
  if (document.webkitHidden) return true
  if (document.msHidden) return true

  return false
}

// Get version of IOS.
const iOSversion = () => {
  var appVersion = window.navigator.appVersion;
  var versionString = appVersion.split('iPhone OS ')[1];
  if (!versionString) return undefined
  versionString = versionString.split(' ')[0];
  var versionArray = versionString.split('_');

  return versionArray;
}

// Get version of Instagram.
const instagramVersion = () => {
  let ua = window.navigator.userAgent
  let igv = ua.split('Instagram')[1]
  if (igv) {
    if (igv.indexOf('iPhone') > -1 || igv.indexOf('Android') > -1) {
      igv = igv.split('(')[0]
      igv = igv.split('.')

      return `${igv[0]}.${igv[1]}`
    }

    return undefined
  } else {
    return undefined
  }
}

// Check if Instagram Version is 28 or Higher
const instagramVersion28OrHigher = () => {
  if (!instagramVersion()) return undefined
  if (parseInt(instagramVersion()) >= 28) return true
}

const isIphoneXInInstagram = () => {
  let ua = window.navigator.userAgent
  let igv = ua.split('Instagram')[1]
  if (igv) {
    if (ua.indexOf('iPhone10') >= 0) {
      // iPhone10 appears for both iPhone 8 and iPhone X, ensure dimensions
      // are correct for iPhone X.
      if (ua.indexOf('1125x2436') >= 0) return true

      return false
    }
    return undefined
  } else {
    return undefined
  }
}

const validateEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const removeProtocolFromUrl = (url) => {
  url = url.replace('https:', '')
  url = url.replace('http:', '')

  return url
}

const slugify = (text) => {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

const getQueryParam = (searchKey) => {
  let match
  let queryParams = window.location.search

  queryParams.split('%26').join('&')
  queryParams.split('%3D').join('=')

  if (queryParams && queryParams[0] == '?') {
    queryParams = queryParams.substring(1)

    let pairArray = queryParams.split('&')
    pairArray.map((pair) => {
      let key = pair.split('=')[0]
      let value = pair.split('=')[1]
      if (key == searchKey) {
        match = value
      }
    })
  }

  return match
}

const getIOSWindowHeight = () => {
  let zoomLevel = document.documentElement.clientWidth / window.innerWidth

  return window.innerHeight * zoomLevel
}

const getHeightOfIOSToolbars = () => {
  let tH = (window.orientation === 0 ? screen.height : screen.width) -  getIOSWindowHeight()

  return tH > 1 ? tH : 0
}

const cartPlatformCheck = (cartSlug, state) => {
  if (state.currentMulticartRetailer) {
    if (state.currentMulticartRetailer == cartSlug) {
      return true
    } else {
      return false
    }
  }
  if (state.currentFocusedProduct && state.currentFocusedProduct.cartPlatform) {
    return state.currentFocusedProduct.cartPlatform == cartSlug
  }
  if (state.currentPlayer.cartPlatform && !state.currentFocusedProduct.cartPlatform) {
    return state.currentPlayer.cartPlatform == cartSlug
  }
  return false
}


const BAXTER_BENCHMARK_TEST = (playerId) => {
  if (!isProduction()) return false
  if (playerId == '23d74c95-b53d-4447-a6a1-fc6f5c8e0fc5' ||
      playerId == '1ff853fe-3575-73e0-6f5d-57f5042b4fbe' ||
      playerId == 'e43300f9-00d7-dc9c-0a0a-c4637d07fd26' ||
      playerId == '4dc0c86b-d1d0-bec0-e684-cc67a14c5c20') {
    let diceRoll = Math.random().toFixed(1)
    if (diceRoll <= 0.1) return true
  }

  return false
}


const NESQUICK_BENCHMARK_TEST = (playerId) => {
  if (!isProduction()) return false
  if (playerId == 'e37d6218-73db-22f7-6553-b36eb494c2b1' ||
      playerId == '78574513-4adf-64f4-7e16-95f04de48f7e' ||
      playerId == '3e06e127-da8f-db38-820d-6bf061b7adf8') {
    let diceRoll = Math.random().toFixed(1)
    if (diceRoll <= 0.1) return true
  }

  return false
}

export default {
  isProduction: isProduction,
  isDesktop: isDesktop,
  isLocalHost: isLocalHost,
  getCurrentDate: getCurrentDate,
  isInstagram: isInstagram,
  isFacebook: isFacebook,
  isSnapchat: isSnapchat,
  isAndroid: isAndroid,
  isInternetExplorer: isInternetExplorer,
  isVisualTest: isVisualTest,
  isTestPurchase: isTestPurchase,
  noPlayDemo: noPlayDemo,
  isGalleryView: isGalleryView,
  getConstantKeyFromStore: getConstantKeyFromStore,
  appIsHidden: appIsHidden,
  hosts: {
    staging: stagingHostName(),
    secureStaging: secureStagingHostName(),
    production: productionHostName(),
    drbrandt: drBrandtHostName(),
    secureProduction: secureProductionHostName()
  },

  isTestEvent: isTestEvent,
  guid: guid,
  sortByKey: sortByKey,
  sortArrayByDate: sortArrayByDate,
  sortArrayByNumber: sortArrayByNumber,

  iOSversion: iOSversion,
  instagramVersion: instagramVersion,
  isIphoneXInInstagram: isIphoneXInInstagram,
  instagramVersion28OrHigher: instagramVersion28OrHigher,
  validateEmail: validateEmail,
  removeProtocolFromUrl: removeProtocolFromUrl,
  slugify: slugify,
  getQueryParam: getQueryParam,
  getHeightOfIOSToolbars: getHeightOfIOSToolbars,
  getIOSWindowHeight: getIOSWindowHeight,
  cartPlatformCheck: cartPlatformCheck,
  NESQUICK_BENCHMARK_TEST: NESQUICK_BENCHMARK_TEST,
  BAXTER_BENCHMARK_TEST: BAXTER_BENCHMARK_TEST
}



// WEBPACK FOOTER //
// ./client/services/utils.js